<div style="height: 80vh" [attr.data-testid]="'preview-'+testid+'-'+material.originalfilename">
  <ng2-pdfjs-viewer [pdfSrc]="materialUrl" #pdfViewer></ng2-pdfjs-viewer>
</div>
